import DateFormat from "../../../util/DateFormat";
import { NumericFormat } from "react-number-format";
import React from "react";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";

export default function Histories({ histories }) {
  return (
    <div
      style={{
        marginTop: calc(10),
        width: "100%",
      }}
    >
      {histories.map((history, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "row",
            padding: `${calc(16)} ${calc(40)}`,
            alignItems: "flex-start",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              flex: 1,
              gap: calc(2),
            }}
          >
            <span
              style={{
                color: "#212121",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(14),
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: calc(20),
                letterSpacing: "-0.2px",
              }}
            >
              {history.description}
            </span>
            <span
              style={{
                color: "#9E9E9E",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(12),
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: calc(18),
                letterSpacing: "-0.2px",
              }}
            >
              {new DateFormat(history.created_at).format("yyyy년 MM월 dd일")}
            </span>
          </div>

          <span
            style={{
              color: history.gain_opportunity > 0 ? "#3DC800" : "#FF6157",
              textAlign: "right",
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(14),
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: calc(20),
              letterSpacing: "-0.2px",
            }}
          >
            {history.gain_opportunity > 0 ? "+" : ""}
            <NumericFormat
              displayType="text"
              thousandSeparator=","
              value={history.gain_opportunity}
            />
            개
          </span>
        </div>
      ))}
    </div>
  );
}
